
module dg.actions {
    export interface IQueryExecutionStrategy {
        executeQuery(query: dg.domain.queries.IQueryAction): ng.IPromise<any>;

        getQuery(link: dg.restfulApi.Link): ng.IPromise<dg.domain.queries.IQueryAction>;
    }

    export class QueryExecutionStrategyFactory {

        private strategies: any = {};

        constructor(private actionService: dg.actions.ActionService,
            private $q: ng.IQService) {

        }

        registerStrategy(strategyName: string, strategy: IQueryExecutionStrategy) {
            if (this.strategies[strategyName]) {
                throw `Strategy ${strategyName} already exists`;
            }
            else {
                this.strategies[strategyName] = strategy;
            }
        }


        getStartegy(strategyName: string): IQueryExecutionStrategy {
            if (this.strategies[strategyName]) {
                return this.strategies[strategyName];
            }
            else {
                return <IQueryExecutionStrategy> {
                    executeQuery: (query) => { return this.actionService.executeQuery(query) },
                    getQuery: (link) => { return this.actionService.getActionFromLink(link) }
                }
            };
        }
    }

    //executeQueryFunc(query: dg.domain.queries.IQueryAction) {
    //    //let deferred = this.$q.defer<any>();
    //    return { executeQuery: this.actionService.executeQuery }

    //    //return deferred.promise;

    //}



    angular.module('dg.actions')
        .service('queryExecutionStrategyFactory', QueryExecutionStrategyFactory)

}
